export const extraParams = {
  withKoniki: '256',
  adr: '64', // TODO: при удалении сайтфичи 3838 надо избавиться от 64 и перейти на новый ниже
  withAdr: 'withAdr',
  roundTrip: '4',
  permanent: '128',
  tenders: 'excludeTenders',
  isRateInThousands: '4096',
  teamDriving: 'teamDriving',
};

export const reverseParams = {
  loggingTruck: 'loggingTruck',
  roundTrip: 'roundTrip',
  permanentCargoApplications: 'permanentCargoApplications',
  tenders: 'tenders',
  teamDriving: 'teamDriving',
  adr: 'adr',
} as const;

export type TReverseParam = typeof reverseParams[keyof typeof reverseParams];

export type TReverseMode = 'include' | 'exclude';

export const includeReverseParams: TReverseParam[] = [
  reverseParams.loggingTruck,
  reverseParams.roundTrip,
  reverseParams.adr,
];

export const visibleExcludeReverseParams: TReverseParam[] = [
  reverseParams.permanentCargoApplications,
  reverseParams.teamDriving,
  reverseParams.adr,
];

export const hiddenExcludeReverseParams: TReverseParam[] = [
  reverseParams.loggingTruck,
  reverseParams.roundTrip,
  reverseParams.tenders,
];

export const excludeReverseParams: TReverseParam[] = [...visibleExcludeReverseParams, ...hiddenExcludeReverseParams];

export const isReverseModeAllowed = (param: TReverseParam, mode: TReverseMode) =>
  (mode === 'include' ? includeReverseParams : excludeReverseParams).includes(param);
